import { createFileRoute, redirect } from '@tanstack/react-router'

// Moved into the Administration hub. Kept as a redirect so old links resolve.
export const Route = createFileRoute('/_app/organization/prompts')({
  beforeLoad: () => {
    throw redirect({ to: '/organization/admin/prompts', search: true })
  },
})
